<template>
  <section class="contact-info-statuses">
    <p><i>Предыдущие звонки:</i></p>
    <el-button
      v-if="list.length"
      type="text"
      class="more-btn"
      @click="onChange"
    >
      {{ full ? 'Скрыть' : 'Показать еще' }}
    </el-button>
    <loader-wrapper :loading="loading" class="height">
      <span v-if="!list.length">
        <el-divider />
        Нет данных
      </span>
      <template v-else>
        <el-row v-for="call in list" :key="call.id">
          <span>
            {{ dateToFormat(call.created_at, 'fullDateWithTimeIn') }}
          </span>
          <el-divider />
          <el-col :span="6" class="call">
            <b>{{ getStatus(call.status) }}</b>
          </el-col>
          <el-col :span="18">
            {{ call.comment }}
          </el-col>
        </el-row>
      </template>
    </loader-wrapper>
  </section>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { callStatuses } from '@/views/CallCenter/constants'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

const CallCenter = RepositoryFactory.get('callCenter')

export default {
  name: 'ContactInfoStatuses',
  components: { LoaderWrapper },
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      full: false,
      calls: [],
      loading: false,
    }
  },
  computed: {
    list() {
      const { full, calls } = this

      return !full && calls ? calls.slice(0, 2) : calls
    },
  },
  watch: {
    id: {
      immediate: true,
      handler(val) {
        this.fetchContact(val)
      },
    },
  },
  methods: {
    fetchContact(id) {
      if (id) {
        this.loading = true
        CallCenter.getContact(id)
          .then(res => {
            const { data } = res

            if (data) {
              this.calls = data.calls
            }
          })
          .catch(err => this.errHandler(err))
          .finally(() => (this.loading = false))
      } else {
        this.calls = []
      }
    },
    getStatus(status) {
      return callStatuses[status] || 'без статуса'
    },
    onChange() {
      this.full = !this.full
    },
  },
}
</script>

<style lang="sass">
.contact-info-statuses
  position: relative
  font-size: 18px
  color: #000
  p
    margin: 30px 0 20px
  .more-btn
    position: absolute
    right: 0
    top: 35px
    text-decoration: underline
    margin: 0
    z-index: 1
    font-weight: normal
  .el-row
    margin-bottom: 35px
  .height
    min-height: 165px
  .call
    color: #FFB800
  .el-divider--horizontal
    margin: 10px 0
</style>
